import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Drawer } from './drawer';

@Injectable()
export class DrawerService {
  data$: Subject<Drawer> = new Subject<Drawer>();
  close$: Subject<boolean> = new Subject<boolean>();
}
